export default __webpack_public_path__ + "static/media/test-assignment-sante24-hero-en.10d165f0.png";